import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
// PAGES
// Login
import Login from './pages/Login';
// Logout
import Logout from './pages/Logout';
// Select company section
import CompanyDashBoard from "./pages/CompanyDashBoard";
// Recovery password
import Recovery from './pages/Recovery';
import PickingSystemV2 from "./pages/PickingSystemV2";
import SetProductStatus from "./pages/SetProductStatus";
import SalesOrderV2 from "./pages/SalesOrderV2";
import InvoicesV2 from "./pages/InvoicesV2";
import CreateCustomerV2 from "./pages/CreateCustomerV2";
import CustomerList from "./pages/CustomerList";
import ShowCustomer from "./pages/ShowCustomer";
import ShowCustomerV2 from "./pages/ShowCustomerV2";
import NewCustomer from "./pages/NewCustomer";
import CustomerSpecialPricing from "./pages/SpecialCustomerPricing";
import MargenesPrecioV2 from "./pages/Reports/MargenesPreciov2";
import GeneralMarginPricesV2 from "./pages/Reports/GeneralMarginPrices/GeneralMarginPricesV2";
import Logistics from "./pages/Reports/Logistics";
import CurrentShippedItemsReport from "./pages/Reports/CurrentShippedItemsReport/CurrentShippedItemsReport";
import CustomerBalance from "./pages/CustomerBalance";
// Dashboard for admin
import AdminLobbyV2 from "./pages/AdminLobbyV2";
import SalesLobbyV2 from "./pages/SalesLobbyV2";
import BlankLobby from "./pages/BlankLobby";
import PayablesLobby from "./pages/PayablesLobby";
// Inventory
import AddNewProduct from './pages/Inventory/AddNewProduct/AddNewProduct';
import Inventory from './pages/Inventory';
// Picking
import SalesPickingSystem from './pages/SalesPickingSystem';
// import ItemPriceException from './pages/ItemPriceException';
import SalesCommissionReport from './pages/Reports/SalesCommissionReport';
// Reports V2 - proper URL routes
import ShortsReport from './pages/Shorts';
import SalesReport from './pages/Reports/Sales';
import MOHReport from './pages/Reports/MOH';
import SalesByRouteReport from './pages/Reports/SalesByRoute/SalesByRoute';
import SalesOrderReport from './pages/Reports/SalesOrderReport/SalesOrderReport';
import SpoilageReport from './pages/Reports/Spoilage';
// Process logs
import QueueLogsDashboard from "./pages/QueueLogsDashboard/QueueLogsDashboard";
// Pre-sale catalog
import PreSaleCatalog from "./pages/PreSaleCatalog";
// import PreSaleSalesOrder from "./pages/PreSaleSalesOrder";
import PreSalesOrder from "./pages/PreSalesOrder";
import PreSaleOrdersList from "./pages/PreSaleOrdersList";
import PreSalePicking from "./pages/PreSalePicking";

export default function AppRouter() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Session */}
        <Route path="/login" element={<Login />} />
        <Route path="/logout" element={<Logout />} />
        <Route path="/recovery" element={<Recovery />} />
        {/* Select company */}
        <Route path="/select-company" element={<CompanyDashBoard />} />
        {/* Process log queue */}
        <Route path="/process-list-mas90" element={<QueueLogsDashboard />} />
        {/* Dashboard */}
        <Route path="/admin/dashboard" element={<AdminLobbyV2 />} />
        <Route path="/sales/dashboard" element={<SalesLobbyV2 />} />
        <Route path="/blank/dashboard" element={<BlankLobby />} />
        <Route path="/payables/dashboard" element={<PayablesLobby />} />
        {/* Inventory */}
        <Route path="/inventory/products" element={<Inventory />} />
        <Route path="/inventory/add-new-product" element={<AddNewProduct />} />
        {/* Sales Routes */}
        <Route path="/sales-orders" element={<SalesOrderV2 />} />
        <Route path="/sales-picking-system" element={<SalesPickingSystem />} />
        <Route path="/sales-commission" element={<SalesCommissionReport showMenu />} />
        {/* Warehouse Routes */}
        <Route path="/picking-system" element={<PickingSystemV2 />} />
        {/* Invoice Routes */}
        <Route path="/invoices" element={<InvoicesV2 />} />
        {/* Item Routes */}
        <Route path="/set-product-status" element={<SetProductStatus />} />
        {/* <Route path="/item-price-exception" element={<ItemPriceException />} /> */}
        {/* Customer Routes */}
        <Route path="/customer-list" element={<ShowCustomerV2 />} />
        {/* <Route path="/show-customer" element={<ShowCustomerV2 />} /> */}
        <Route path="/new-customer" element={<CreateCustomerV2 />} />
        <Route path="/update-customer" element={<NewCustomer />} />
        <Route path="/customer-special-pricing" element={<CustomerSpecialPricing />} />
        <Route path="/customer-balance" element={<CustomerBalance />} />
        {/* Pricing Routes */}
        <Route path="/price_margins" element={<MargenesPrecioV2 />} />
        <Route path="/general-margin-prices" element={<GeneralMarginPricesV2 />} />
        {/* Reports */}
        <Route path="/report-logistics" element={<Logistics />} />
        <Route path="/report-current-shipped-items" element={<CurrentShippedItemsReport />} />
        {/* Pre-sale catalog */}
        <Route path="/pre-sales/catalog" element={<PreSaleCatalog />} />
        
        {/* Pre-sale new order V1 */}
        <Route path="/pre-sales/new-order" element={<PreSalesOrder />} />
        <Route path="/pre-sales/edit-order" element={<PreSalesOrder />} />
        {/* Pre-sale new order V2 */}
        {/* <Route path="/pre-sales/new-order" element={<PreSaleSalesOrder />} /> */}
        
        {/* Pre-sale orders */}
        <Route path="/pre-sales/orders" element={<PreSaleOrdersList />} />
        <Route path="/pre-sales/picking" element={<PreSalePicking />} />

        {/* Reports V2 - proper URL routes calling RDS mirror endpoints */}
        <Route path="/reports/shorts" element={<ShortsReport showMenu />} />
        <Route path="/reports/sales" element={<SalesReport showMenu />} />
        <Route path="/reports/moh" element={<MOHReport showMenu />} />
        <Route path="/reports/sales-by-route" element={<SalesByRouteReport showMenu />} />
        <Route path="/reports/sales-orders" element={<SalesOrderReport showMenu />} />
        <Route path="/reports/sales-commission" element={<SalesCommissionReport showMenu />} />
        <Route path="/reports/spoilage" element={<SpoilageReport showMenu />} />

        {/* Ruta por defecto para usar el sistema show/hide V1 */}
        <Route path="/" element={<Login />} />
      </Routes>
    </BrowserRouter>
  );
}
